module.exports = __webpack_public_path__ + "img/FedoraProject.73a94ae.svg";